import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import { iconWithLabelStyles as styles } from '../../../constants/constants';
import dataAids from '../../../constants/dataAids';

const IconWithLabel = ({
  containerMarginBottom,
  containerMarginTop,
  icon,
  iconElement,
  iconSize,
  labelDataAidKey,
  labelElement,
  labelText
}) => {
  const { Element, Icon } = UX2.Element;
  const LabelElement = !labelElement ? UX2.Element.Details : labelElement;
  return (
    <LabelElement
      className='icon-with-label-container'
      style={{ ...styles.row, marginBottom: containerMarginBottom, marginTop: containerMarginTop }}
    >
      <Element style={ styles.iconContainer }>
        { iconElement ? iconElement : <Icon style={ styles.icon } icon={ icon } size={ iconSize } /> }
      </Element>

      <Element data-aid={ labelDataAidKey && dataAids[labelDataAidKey] } style={{ ...styles.label }}>
        { labelText }
      </Element>
    </LabelElement>
  );
};

IconWithLabel.defaultProps = {
  containerMarginBottom: 'small',
  containerMarginTop: 'none',
  iconSize: 'medium'
};

IconWithLabel.propTypes = {
  containerMarginBottom: PropTypes.string,
  containerMarginTop: PropTypes.string,
  icon: PropTypes.string.isRequired,
  iconSize: PropTypes.string,
  iconElement: PropTypes.object,
  labelDataAidKey: PropTypes.string,
  labelText: PropTypes.string.isRequired,
  labelElement: PropTypes.object
};

export default IconWithLabel;
